<template>
<main id="main" role="main" class="main">
    <div class="section">
        <div class="container">
            <template v-for="block, i in site_data.blocks">
                <component :is="block.type" :block="block" />
            </template>
        </div>
    </div>
</main>
</template>

<script>
import * as components from '../blocks/modules'
export default {
    name        :   'Homepage',
    props       :   ['site_data'],
    components,
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Homepage.vue